export default __webpack_public_path__ + "static/media/history_1.a6a49e9e.png";